<template>
  <div
    class="modal"
    :class="position"
    @click.stop="toggleModal()"
    v-if="showModal">
    <div class="modal-wrapper">
      <div class="header">
        <slot name="header"/>
        <div
          class="close"
          @click.stop="toggleModal">
          <i class="n-i n-i-close-a" />
        </div>
      </div>
      <slot name="body"/>
      <slot name="footer"/>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModal: true,
    };
  },
  methods: {
    toggleModal() {
      this.showModal = !this.showModal;
      this.$emit('modalclosed');
    },
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    position: {
      type: String,
      required: false,
      default: () => '',
    },
  },
  mounted() {
    this.showModal = this.show;
  },
  watch: {
    show(newValue) {
      this.showModal = newValue;
    },
  },
};
</script>


<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1001;

  &.betslip-stake {
    display: flex;
    right: 0 !important;
    margin-top: unset;
    align-items: center;
    justify-content: center;

    .modal-wrapper {
      margin-top: 15%;
      width: 20%;
      margin-left: 80%;
    }
  }

  &.statistics-modal {
    right: 2%;
    left: 2%;
    bottom: 0;
    top: 2%;
    height: auto;
    min-height: 100% !important;

    .modal-wrapper {
      margin-top: 0;
      width: 100%;
      display: block;
      overflow: auto;
      margin-left: 0;
      height: auto;
      min-height: 100% !important;

      iframe {
        height: auto;
        min-height: 93% !important;
        position: absolute;
        top: 50px;
        bottom: 50px;
      }
    }
  }
}

.modal-wrapper {
  width: 50%;
  margin-top: 115px;
  margin-left: 25%;
  background: #323232;
}

.header {
  position: relative;
  border-left: 5px solid #0066ae;
  height: 50px;
  line-height: 50px;
  padding-left: 10px;
  font-size: 25px;
}

.close {
  position: absolute;
  right: 10px;
  top: 0px;
  font-weight: 300;
  text-align: center;
  font-size: 25px;
}
</style>
